// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__-Y6Cf","col":"styles_col__2AG6P","fulfillmentStatus":"styles_fulfillmentStatus__1c6Q-","emailCol":"styles_emailCol__13-Ad"};